import axios from 'axios';

export const getLinks = async () => {
    const apiUrl = `${process.env.REACT_APP_SERVER_URL}/link/`;
    try {
        const response = await axios.get(apiUrl);
        console.log(JSON.stringify(response.data))
        return response.data;
    } catch (error) {
        console.error('Error fetching user:', error);
        throw error;
    }
};
